



























import {Prop, Vue, Component} from "vue-property-decorator";
import LoadingIndicator from "@/view/shared-components/LoadingIndicator.vue";
@Component({
    components: {LoadingIndicator},
})
export default class UploadFile extends Vue {
    @Prop({required: true})uploading!: boolean;

    private formData = new FormData();
    private uploadReady:boolean = false;
    private fileName:string = '';
    private fileSize:number = 0;
    //private $refs: any;

    mounted(){
        window.addEventListener("dragover",function(e){
            e = e || event;
            e.preventDefault();
        }, false);
        window.addEventListener("drop",function(e){
            e = e || event;
            e.preventDefault();
        }, false);
        this.dragFileEventListener();
    }

    dragFileEventListener(){
        let self = this;
        (this.$refs.fileform as any).addEventListener('drop', function(e){
            self.fileChange(e.dataTransfer.files)
        }.bind(self));
    }

    clearFile(e){
        this.uploadReady = false;
        e.preventDefault();
        this.$nextTick(() => {
            this.formData.delete("file");
            this.dragFileEventListener();
        })
    }
    fileChange( fileList ) {
        this.fileSize = fileList[0].size;
        this.fileName = fileList[0].name;
        this.formData.append("file", fileList[0], this.fileName);
        this.uploadReady = true;
    }
    uploadFile(){
        if (this.uploadReady) {
            this.$emit('uploadFile', this.formData, this.fileName);
        } else {
            alert("Please select a file to upload!")
        }
    }
}
